import Logo from "../../images/logo/logo.png";
import InstagramIcon from "../../images/logo/instagram.png";
import WhatsAppIcon from "../../images/logo/whatsapp.png";

function Footer() {
  return (
    <>
      <footer className="bg-white text-black">
        <div className="container page-padding py-[6rem] min620:py-[4rem]">
          {/* footer grid */}
          <div className="grid grid-cols-3 gap-12 min620:grid-cols-1 min620:gap-10">
            
            {/* logo & about */}
            <div className="flex flex-col gap-5">
              <div className="flex items-center gap-3">
                <img src={Logo} alt="logo" className="w-[60px] min620:w-[50px]" />
                <h2 className="text-black text-[2.4rem] min620:text-[2rem] font-bold">
                  AKFITNESS
                </h2>
              </div>
              <p className="text-[14px] font-medium text-[#555] leading-relaxed">
                Take your health and body to the next level with our
                comprehensive program designed to help you reach your fitness
                goals.
              </p>
              {/* socials */}
              <div className="flex gap-5">
                <a
                  href="https://www.instagram.com/akfitnessjbp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={InstagramIcon} alt="instagram" className="w-[3rem] h-[3rem] object-contain cursor-pointer hover:scale-110 ease-in duration-200" />
                </a>
                <a
                  href="https://wa.me/919406761177"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={WhatsAppIcon} alt="whatsapp" className="w-[3rem] h-[3rem] object-contain cursor-pointer hover:scale-110 ease-in duration-200" />
                </a>
              </div>
            </div>

            {/* sessions & hours - side by side on mobile */}
            <div className="flex flex-col gap-5 min620:flex-row min620:gap-8">
              {/* sessions removed */}

              {/* working hours - visible only on mobile in this column */}
              <div className="hidden min620:flex flex-col gap-3 min620:flex-1">
                <p className="text-[16px] font-bold text-black uppercase relative pb-3">
                  Hours
                  <span className="absolute bottom-0 left-0 w-[5rem] h-[3px] bg-[#ff0336]"></span>
                </p>
                <p className="text-[13px] text-[#555] font-medium">
                  <span className="font-bold text-black">Mon - Sat</span><br />
                  6:00 AM - 10:00 PM
                </p>
                <p className="text-[13px] text-[#555] font-medium">
                  <span className="font-bold text-black">Sunday</span><br />
                  8:00 AM - 12:00 PM
                </p>
              </div>
            </div>

            {/* working hours & contact - desktop only column */}
            <div className="flex flex-col gap-5 min620:hidden">
              <p className="text-[18px] font-bold text-black uppercase relative pb-3">
                Working Hours
                <span className="absolute bottom-0 left-0 w-[5rem] h-[3px] bg-[#ff0336]"></span>
              </p>
              <div className="flex flex-col gap-1">
                <p className="text-[14px] text-black font-bold">Monday - Saturday:</p>
                <p className="text-[14px] text-[#555] font-medium">6:00 AM - 10:00 PM</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-[14px] text-black font-bold">Sunday:</p>
                <p className="text-[14px] text-[#555] font-medium">8:00 AM - 12:00 PM</p>
              </div>
              <div className="flex flex-col gap-2 mt-2">
                <p className="text-[14px] text-black font-bold">Contact Us:</p>
                <p className="text-[14px] text-[#555] font-medium">
                  <i className="fa-solid fa-envelope text-[#ff0336] text-[12px]"></i>&nbsp; akfitnessjbp@gmail.com
                </p>
                <p className="text-[14px] text-[#555] font-medium">
                  <i className="fa-solid fa-phone text-[#ff0336] text-[12px]"></i>&nbsp; +91 94067 61177
                </p>
                <p className="text-[14px] text-[#555] font-medium">
                  <i className="fa-solid fa-location-dot text-[#ff0336] text-[12px]"></i>&nbsp; Atulyam Towers, Tilwara Road Near Sagda Chowk, Jabalpur, 482003
                </p>
              </div>
            </div>

            {/* contact - mobile only */}
            <div className="hidden min620:flex flex-col gap-3">
              <p className="text-[16px] font-bold text-black uppercase relative pb-3">
                Contact Us
                <span className="absolute bottom-0 left-0 w-[5rem] h-[3px] bg-[#ff0336]"></span>
              </p>
              <p className="text-[13px] text-[#555] font-medium">
                <i className="fa-solid fa-envelope text-[#ff0336] text-[12px]"></i>&nbsp; akfitnessjbp@gmail.com
              </p>
              <p className="text-[13px] text-[#555] font-medium">
                <i className="fa-solid fa-phone text-[#ff0336] text-[12px]"></i>&nbsp; +91 94067 61177
              </p>
              <p className="text-[13px] text-[#555] font-medium">
                <i className="fa-solid fa-location-dot text-[#ff0336] text-[12px]"></i>&nbsp; Atulyam Towers, Tilwara Road Near Sagda Chowk, Jabalpur, 482003
              </p>
            </div>
          </div>

          {/* bottom bar */}
          <div className="border-t border-gray-200 mt-10 min620:mt-6 pt-6 min620:pt-4 flex justify-between items-center min620:flex-col min620:gap-2">
            <p className="text-[13px] font-medium text-[#888]">
              © {new Date().getFullYear()} AK Fitness. All rights reserved.
            </p>
            <p className="text-[13px] font-medium text-[#888]">
              Privacy Policy
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
